import LandingPageLayout from "../../components/landingPageLayout";
import { Col, Container, Row } from "react-bootstrap";
import fourthsection from "../../assets/images/folder.png";
import sixthimg from "../../assets/svg/about_icon.svg";
import styles from "../aboutUs/AboutUs.module.scss";
import Third from "../landingpages/third/third";
import img from "../../assets/images/aboutusimg.png";
import img2 from "../../assets/images/aboutusimg2.png";
import Feature from "../landingpages/features/feature";
import { useEffect } from "react";

const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <LandingPageLayout>
      <>
        <div className={styles.aboutUsWrapper}>
          <div className={styles.aboutUsContent}>
            <div className={styles.aboutUsHeader}>
              <h1>About Us</h1>
            </div>
          </div>
        </div>

        <Container>
          <Row>
            <Col className="text-right" md={12} lg={7} xl={8}>
              <div className={styles.head}>
                {/* <img src={logo} alt="" /> */}
                <span>
                  Safety and compliance don’t have to be afterthoughts
                </span>{" "}
                <i className={styles.italic}>
                  Prioritize Safety and Compliance from the Start – Construction
                  Code Inspections Done Right!
                </i>
                <p>
                  {" "}
                  With a steadfast commitment to safety and compliance, CID
                  brings a wealth of experience and precision to guide your
                  construction projects to success. We understand the unique
                  nuances of New Jersey's building regulations and ensure every
                  inspection is thorough and precise.
                </p>
              </div>
            </Col>
            <Col md={12} lg={5} xl={4}>
              <div className={styles.img}>
                <img src={img} />
              </div>
            </Col>

            <Col md={12} lg={5} xl={4}>
              <div className={`${styles.img} ${styles.img_new}`}>
                <img src={img2} />
              </div>
            </Col>
            <Col className="d-flex" md={12} lg={7} xl={8}>
              <div className={styles.head_}>
                <p>
                  At CID, we embrace innovation. Our digital solution
                  revolutionizes the construction inspection process, offering
                  an end-to-end construction code inspection management
                  platform. Bringing together stakeholders such as townships,
                  builders/contractors, and inspectors, our cohesive platform
                  streamlines all operations. Our platform ensures seamless
                  record-keeping, efficient scheduling, real-time monitoring,
                  and insightful analytics while handling integrated operations
                  for all stakeholders within the construction code inspection
                  universe.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
        <Container>
          <div className={styles.thirdSection}>
            <h2>4 Great reasons why should choose us</h2>
            <img src={sixthimg} />
            <Row>
              <Col md={6} lg={3}>
                <div className={styles.firstcard}>
                  <h3>TRANSPARENCY</h3>
                </div>
              </Col>
              <Col md={6} lg={3}>
                <div className={styles.firstcard}>
                  {" "}
                  <h5></h5>
                  <h3>COMPLIANCE</h3>
                </div>
              </Col>
              <Col md={6} lg={3}>
                <div className={styles.firstcard}>
                  {" "}
                  <h5></h5>
                  <h3>QUALITY</h3>
                </div>
              </Col>
              <Col md={6} lg={3}>
                <div className={styles.firstcard}>
                  {" "}
                  <h5></h5>
                  <h3>EFFICIENCY</h3>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
        <div className={styles.fourthsection}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-6 p-0">
                <div className={styles.fourthleft}>
                  <img src={fourthsection} alt="" />
                </div>
              </div>
              <div className="col-lg-6">
                <div className={styles.fourthright}>
                  <div className={styles.main_}>
                    <h2>Our mission extends beyond inspections</h2>
                    <p className={styles.headertext}>
                      We are dedicated to creating secure environments. Whether
                      it's a new construction project or a renovation, CCI
                      guarantees accuracy in meeting every code requirement by
                      uniting townships, builders/contractors, and inspectors on
                      a cohesive digital platform.
                      <br />
                      This digital approach promotes transparency, ensures
                      quality service, and simplifies the construction journey.
                      Experience the CCI difference where professionalism,
                      expertise, and innovation converge to elevate your
                      construction journey. Your vision and our commitment
                      building excellence together. Welcome to a future-focused
                      approach to construction code inspections.
                      <br />
                      Explore the difference with CID where professionalism,
                      knowledge, and innovation converge to elevate your
                      construction experience.
                    </p>
                    {/* <div className="d-flex align-items-start">
                      <span className="me-3">01</span>
                      <p>
                        It is a long established fact that a reader will <br />
                        be distracted by the readable content.
                      </p>
                    </div> */}
                    {/* <div className="d-flex align-items-start">
                      <span className="me-3">02</span>
                      <p> It is a long established fact that a reader.</p>
                    </div>
                    <div className="d-flex align-items-start">
                      <span className="me-3">03</span>
                      <p>
                        {" "}
                        It is a long established fact that a reader will
                        <br /> be distracted by the readable content.
                      </p>
                    </div>
                    <div className="d-flex align-items-start">
                      <span className="me-3">04</span>
                      <p>
                        {" "}
                        It is a long established fact that a reader will
                        <br /> be distracted by the readable content of a<br />{" "}
                        page when looking at its layout.
                      </p>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Third />
        {/* <FourAboutus /> */}
        <Feature />
        {/* <Eightaboutus /> */}
        {/* <Container>
          <Row>
            <div className="col-lg-7 align-items-center">
              <div className="d-flex align-items-end">
                <div className={styles.sixthSection}>
                  <img src={aboutussecondicon} alt="" />
                  <h2>You Can Trust Our Expert Team</h2>
                  <p>
                    It is a long established fact that a reader will be
                    distracted by <br />
                    the readable content of a page when looking at its layout.
                    The <br /> point of using Lorem Ipsum is that it has a
                    more-or-less
                    <br />
                    normal distribution of letters, as opposed to using 'Content
                    <br />
                    here, content here', making it look like readable English.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-5  text-align-center">
              <div className={styles.sixthright}>
                {" "}
                <img src={sixthimg} alt="" />
              </div>
            </div>
          </Row>
          <div className={styles.manage_inspection_need}>
            <div>
              <div className={styles.manage_your_inspection}>
                <div className={styles.tick_list}>
                  <img src={tick1} alt="" />
                  <span>Foundation/Backfill</span>
                </div>
                <div className={styles.tick_list}>
                  <img src={tick1} alt="" />
                  <span>Foundation/Backfill</span>
                </div>
                <div className={styles.tick_list}>
                  <img src={tick1} alt="" />
                  <span>Foundation/Backfill</span>
                </div>
              </div>
            </div>
          </div>
        </Container> */}
      </>
    </LandingPageLayout>
  );
};

export default AboutUs;
